import styled from "styled-components";
import { MainWrapperDefaultBox } from "./main-wrapper.default.box";

export const MainWrapperMrgreenCisBox = styled(MainWrapperDefaultBox)`
    background-color: ${props => props.theme.colors.backgroundContrast};
`;
